const plans = [
  {
    id: '765414191',
    provisioning_id: '70014466',
    status: 'active',
    customer_login: 'qalwwpnorm1',
    customer_id: '1100426699',
    contract_key: 'hosting_wordpress_performance',
    consumption: {
      limit: 5,
      consumed: 3
    }
  }, {
    id: '764515112',
    provisioning_id: '69095684',
    status: 'active',
    customer_login: 'meuwordpress',
    customer_id: '1100025524',
    contract_key: 'hosting_wordpress_pro',
    consumption: {
      limit: 10,
      consumed: 3
    }
  }, {
    id: '764508427',
    provisioning_id: '60705718',
    status: 'active',
    customer_login: 'meuwordpress',
    customer_id: '1100025524',
    contract_key: 'hosting_wordpress_starter',
    consumption: {
      limit: 1,
      consumed: 0
    }
  }, {
    id: '765414935',
    provisioning_id: '700147455',
    status: 'activating',
    customer_login: 'qalwwpnorm1',
    customer_id: '1100426699',
    contract_key: 'hosting_wordpress_performance',
    consumption: {
      limit: 5,
      consumed: 0
    }
  }
]
export default (server) => {
  plans.forEach(plan => {
    server.create('plan', plan)
  })
}
